import { infiniteQueryOptions, keepPreviousData } from '@tanstack/react-query'

import type { MissingSkuQueryParams } from '../types/stockImports.types'
import { stockImportsApi } from './stockImportsApi'

export const MISSING_SKU_PAGE_SIZE = 50

export const stockImportsQueries = {
  all: () => ['stockImports'] as const,
  missingSkuLists: () => [...stockImportsQueries.all(), 'missingSku'] as const,
  missingSku: (logId: string, params: MissingSkuQueryParams) =>
    infiniteQueryOptions({
      queryKey: [...stockImportsQueries.missingSkuLists(), logId, params],
      queryFn: ({ pageParam, signal }) =>
        stockImportsApi.getMissingSku(
          logId,
          { ...params, page: pageParam, pageSize: MISSING_SKU_PAGE_SIZE },
          { signal }
        ),
      initialPageParam: 0,
      getNextPageParam: (lastPage, allPages) => {
        const loadedCount = allPages.reduce(
          (count, page) => count + page.content.length,
          0
        )
        return lastPage.content.length > 0 &&
          loadedCount < lastPage.totalElements
          ? allPages.length
          : undefined
      },
      placeholderData: keepPreviousData,
    }),
}
